module.exports = __webpack_public_path__ + "static/UAmobSlide4-795e37abdfaa79e548dc4ce74877ede5.jpg";